import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HeartPulseIcon, HomeIcon, LayoutGridIcon, ShoppingBagIcon, UserIcon } from 'lucide-react';
import { haptics } from '../../lib/utils/haptics';
const navItems = [{
  icon: HomeIcon,
  label: 'Home',
  path: '/'
}, {
  icon: LayoutGridIcon,
  label: 'Categories',
  path: '/categories'
}, {
  icon: ShoppingBagIcon,
  label: 'Orders',
  path: '/account/orders'
}, {
  icon: HeartPulseIcon,
  label: 'RX',
  path: '/rx'
}, {
  icon: UserIcon,
  label: 'Account',
  path: '/account'
}];
export function MobileFooterNav() {
  const navigate = useNavigate();
  const location = useLocation();
  return <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-100 bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.03)] safe-area-bottom md:hidden" aria-label="Main navigation" data-id="element-2444" data-mp="oma8l12xf54s">
      <div className="flex h-[60px] items-center justify-around px-2" data-id="element-2445" data-mp="34g107tu1feyn">
        {navItems.map(item => {
        const isActive = location.pathname === item.path || item.path !== '/' && location.pathname.startsWith(item.path);
        const Icon = item.icon;
        return <button key={item.path} type="button" onClick={() => {
          haptics.selection();
          navigate(item.path);
        }} aria-current={isActive ? 'page' : undefined} className={`relative flex h-full w-full flex-col items-center justify-center gap-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand ${isActive ? 'text-brand' : 'text-gray-400'}`} data-id="element-2446" data-mp="2mlfeke0omvzx">
              <motion.span whileTap={{
            scale: 0.92
          }} animate={{
            scale: isActive ? 1.06 : 1,
            y: isActive ? -1 : 0
          }} transition={{
            type: 'spring',
            stiffness: 420,
            damping: 24
          }} data-id="element-2447" data-mp="3f801n2a4klxo">
                <Icon className="h-5.5 w-5.5" strokeWidth={isActive ? 2.2 : 1.7} aria-hidden="true" data-id="element-2448" data-mp="3o9r663sximpy" />
              </motion.span>
              <span className={`text-[10px] tracking-tight ${isActive ? 'font-bold' : 'font-medium'}`} data-id="element-2449" data-mp="2lx4qauqbak5d">{item.label}</span>
            </button>;
      })}
      </div>
    </nav>;
}